// Debug output for local development (`npm start`) only. Create React App replaces
// process.env.NODE_ENV at build time, so in a production build this prints nothing.
// Never pass tokens, codes or signed URLs to it: a dev console is still a console.
export function devLog(...args) {
  if (process.env.NODE_ENV === 'development') {
    console.log(...args);
  }
}
